import { type UseFormRegisterReturn } from 'react-hook-form'

interface CheckboxFieldProps {
  label: string
  registration: UseFormRegisterReturn
  error?: string
}

function CheckboxField({ label, registration, error }: CheckboxFieldProps) {
  return (
    <div className="mb-2 md:col-span-2">
      <label className="flex items-start gap-3">
        <input
          type="checkbox"
          className="mt-0.5 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          {...registration}
        />
        <span className="text-sm text-gray-700">{label}</span>
      </label>
      {error ? <p className="mt-1 text-xs text-red-600">{error}</p> : null}
    </div>
  )
}

export default CheckboxField
